export default __webpack_public_path__ + "static/media/membership_super_member.44a0b743.svg";